import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { Table, Pagination, Tooltip, Input, CheckboxTable, DatePicker, Select, Modal } from 'components';
import { 
	SurveyIcon,
	MailIcon, 
	TrashIcon, 
	EditIcon, 
	CleanIcon, 
	AddWhiteIcon, 
	TrashWhiteIcon, 
	ViewIcon, 
	PrintIcon, 
	OperatorsIcon, 
	ConfirmIcon, 
	StarIcon, 
	CanceledIcon, 
	MoneyIcon, 
	CopyIcon
} from 'assets/icons';
import { Globals, Constants, Colors, checkPermission, Print } from 'utils';
import { QuoteService } from 'services';
import moment from 'moment';
import ModalOperators from './modal-operators';
import ModalEditOperators from './modal-edit-operators';
import ModalView from './modal-view';
import ModalEdit from './modal-edit';
import ModalChangeDate from './modal-change-date';
import ModalChangeStatusPayment from './modal-change-status-payment';
import ModalChangePrice from './modal-change-price';
import ModalCreate from './modal-create';
import queryString from 'query-string';
import ModalSurvey from './modal-survey';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	since: '',
	until: '',
	status: '',
	type_id: '',
	origin: ''
}

declare var window: any;

class Quotes extends React.Component<Props> {

	timer: any = undefined;

	state = {
		form: INITIAL_STATE,
		page: 1,
		last_page: 1,
		data: [],
		header: [
			'Nº Orden',
			'Cliente',
			'Tipo',
			'Fecha y Hora',
			'Servicio',
			'Superficie',
			'Operarios asignados',
			'Estatus',
			'Estatus del Pago',
			'Origen',
			'Acciones'
		],
		visible_operators: false,
		visible_edit: false,
		visible_view: false,
		visible_edit_operators: false,
		item: null,
		visible_date: false,
		visible_confirm: false,
		visible_status: false,
		visible_confirm_cancel: false,
		visible_cancel: false,
		visible_payment: false,
		visible_price: false,
		visible_copy_link: false,
		quote_types: [],
		visible_create: false,
		user_id_from_clients: null,
		updated_title: '',
		payment_link: '',
		visible_confirm_copy: false,
		visible_survey: false
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Registro de Citas',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await QuoteService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
			per_page: 20
		});
		await this.setState({
			data: res.quotes.rows,
			last_page: res.quotes.count,
			quote_types: res.quote_types
		},() => callback());

		const {
			create_from_user,
			user_id
		} = queryString.parse(this.props.location.search);

		setTimeout(() => {
			if (create_from_user && user_id) {
				this.setState({
					visible_create: true,
					user_id_from_clients: user_id
				},() => {
					const queryParams = new URLSearchParams(this.props.location.search);
					queryParams.delete('create_from_user');
					queryParams.delete('user_id');
					this.props.history.replace({
				        search: queryParams.toString()
				    });
				});
			}
		},500);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	getColor = (service: any) => {
		switch(service.status) {
			case Constants.QUOTE_STATUS.FINISH:
				return Colors.green;
			break;

			case Constants.QUOTE_STATUS.PENDING:
				return Colors.danger;
			break;

			case Constants.QUOTE_STATUS.IN_PROGRESS:
				return Colors.yellow;
			break;

			case Constants.QUOTE_STATUS.CANCELLED:
				return Colors.blue;
			break;
		}
	}

	getPaymentColor = (service: any) => {
		if (service.payment_method_id == Constants.PAYMENT_METHODS.CORPORATE) {
			return Colors.corporate;
		}

		switch(service.status_payment) {
			case Constants.QUOTE_PAYMENT_STATUS.PENDING:
				return Colors.yellow;
			break;

			case Constants.QUOTE_PAYMENT_STATUS.REJECTED:
				return Colors.danger;
			break;

			case Constants.QUOTE_PAYMENT_STATUS.APPROVED:
				return Colors.green;
			break;
		}
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			item,
			visible_edit: true
		});
	}

	view = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			item,
			visible_view: true
		});
	}

	viewSurvey = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			item,
			visible_survey: true
		});
	}

	operators = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			item,
			visible_edit_operators: true
		});
	}

	viewOperators = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			item,
			visible_operators: true
		});
	}

	print = async (e: any, item: any) => {
		e.preventDefault();
		const res: any = await QuoteService.admin.download({
			quote_id: item.id
		});
		if (window.webkit && window.webkit.messageHandlers) {
			const message = 'open_url';
			const sendToNative = {
				message,
				url: Constants.BASE_STORAGE + res.url
			}
			const stringifiedMessageObj = JSON.stringify(sendToNative);
	        window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
	    }
	    else {
	    	Print(Constants.BASE_STORAGE + res.url);
	    }
	}

	resendMail = async (e: any, item: any) => {
		e.preventDefault();
		await QuoteService.admin.resendMail({
			quote_id: item.id
		});
		Globals.showSuccess("Se ha enviado el correo correctamente");
	}

	onCloseView = () => {
		this.setState({
			visible_view: false,
			item: null
		});	
	}

	onCloseOperators = () => {
		this.setState({
			visible_operators: false,
			item: null
		});	
	}
	onCloseSurvey = () => {
		this.setState({
			visible_survey: false,
			item: null
		});	
	}

	onCloseEdit = (open_date: boolean = false) => {
		const item: any = this.state.item;

		this.setState({
			visible_edit: false,
			item: null
		},() => {
			if (open_date) {
				this.setState({
					visible_date: true,
					item
				});
			}
		});	
	}

	onCloseEditOperators = () => {
		this.setState({
			visible_edit_operators: false,
			item: null
		},() => this.load(true));	
	}

	onCloseDate = (open_operators: boolean = false, item: any = null) => {
		this.setState({
			visible_date: false,
			item: null
		},() => this.load(true,() => {
			if (open_operators)
				this.setState({
					visible_edit_operators: true,
					item
				});
		}));
	}

	onCloseStatus = () => {
		this.setState({
			visible_status: false,
			item: null
		});
	}

	onCloseConfirm = () => {
		this.setState({
			item: null,
			visible_confirm: false
		});
	}

	changeStatus = async () => {
		await QuoteService.admin.changeStatus({
			// @ts-ignore
			quote_id: this.state.item?.id
		});
		this.setState({
			item: null,
			visible_confirm: false,
			visible_status: true
		},() => this.load(true));
	}

	showConfirmStatus = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			item,
			visible_confirm: true
		});
	}

	showConfirmPaymentStatus = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			item,
			visible_payment: true
		});
	}

	onCloseConfirmCancel = () => {
		this.setState({
			visible_confirm_cancel: false,
			item: null
		});
	}

	onCloseCancel = () => {
		this.setState({
			visible_cancel: false,
			item: null
		});
	}

	onClosePayment = (reload: boolean = false) => {
		this.setState({
			visible_payment: false,
			item: null,
			updated_title: ''
		},() => {
			this.load(true);
		});
	}

	cancel = async () => {
		await QuoteService.admin.cancelQuote({
			// @ts-ignore
			quote_id: this.state.item?.id
		});
		this.setState({
			visible_confirm_cancel: false,
			visible_cancel: true
		},() => this.load(true));
	}

	confirmCancel = (e: any, item: any) => {
		e.preventDefault();
		e.stopPropagation();
		this.setState({
			visible_confirm_cancel: true,
			item
		});
	}

	onClosePrice = () => {
		this.setState({
			visible_price: false,
			item: null
		},() => this.load(true));
	}

	editPrice = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_price: true,
			item
		});
	}

	onCloseCreate = () => {
		this.setState({
			visible_create: false
		},() => this.load(true));
	}

	add = () => {
		this.setState({
			visible_create: true
		});
	}

	generateLink = async (e: any, item: any) => {
		e.preventDefault();
		const res: any = await QuoteService.admin.generateLink({
			quote_id: item.id
		});
		this.setState({
			visible_copy_link: true,
			payment_link: res.payment_link
		});
	}

	onCloseCopyLink = () => {
		this.setState({
			visible_copy_link: false,
			visible_confirm_copy: false
		});
	}
	
	render() {
		const { 
			visible_operators, 
			visible_edit, 
			visible_view, 
			visible_edit_operators, 
			visible_date, 
			visible_status, 
			visible_confirm, 
			visible_cancel, 
			visible_confirm_cancel,
			visible_payment,
			visible_price,
			visible_create,
			updated_title,
			visible_copy_link,
			visible_confirm_copy,
			visible_survey
		} = this.state;
		let next_status: string = '';
		const item: any = this.state.item;

		// @ts-ignore
		switch(this.state.item?.status) {
			case Constants.QUOTE_STATUS.PENDING:
				next_status = 'Asignada';
			break;

			case Constants.QUOTE_STATUS.ASSIGNED:
				next_status = 'En proceso';
			break;

			case Constants.QUOTE_STATUS.IN_PROGRESS:
				next_status = 'Finalizada';
			break;
		}

		return (
			<div id="quotes">
				<BackComponent />

				<Modal
		          className="modal-quotes-operators"
		          visible={ visible_operators }
		          title="Operarios a cargo"
		          centered
		          onClose={ () => this.onCloseOperators() }
		        >
		        	<ModalOperators
		        		onClose={ () => this.onCloseOperators() }
		        		item={ this.state.item }
		        	/>
		      	</Modal>

		      	<Modal
		          className="modal-survey"
		          visible={ visible_survey }
		          title=""
		          centered
		          onClose={ () => this.onCloseSurvey() }
		        >
		        	<ModalSurvey
		        		
		        		onClose={ () => this.onCloseSurvey() }
		        		item={ this.state.item }
		        	/>
		      	</Modal>

		      	<Modal
		          className="modal-change-date"
		          visible={ visible_date }
		          title=""
		          centered
		          withoutClose={ true }
		          onClose={ () => this.onCloseDate() }
		        >
		        	<ModalChangeDate
		        		onClose={ (open_operators: boolean = false, quote: any = null) => this.onCloseDate(open_operators,quote) }
		        		item={ this.state.item }
		        	/>
		      	</Modal>

		      	<Modal
		          className="modal-quotes-create"
		          visible={ visible_create }
		          onClose={ () => this.onCloseCreate() }
		        >	
		        	{/*
		        	// @ts-ignore */}
		        	<ModalCreate
		        		history={ this.props.history }
		        		user_id_from_clients={ this.state.user_id_from_clients }
		        		onClose={ () => this.onCloseCreate() }
		        	/>
		      	</Modal>

		      	<Modal
		          className="modal-change-price"
		          visible={ visible_price }
		          title=""
		          centered
		          withoutClose={ true }
		          onClose={ () => this.onClosePrice() }
		        >
		        	<ModalChangePrice
		        		onClose={ () => this.onClosePrice() }
		        		item={ this.state.item }
		        	/>
		      	</Modal>

		      	<Modal
		          className="modal-quotes-view"
		          visible={ visible_view }
		          title="Orden de Servicio"
		          centered
		          onClose={ () => this.onCloseView() }
		        >
		        	<ModalView
		        		onClose={ () => this.onCloseView() }
		        		item={ this.state.item }
		        	/>
		      	</Modal>

		      	<Modal
		          className="modal-quotes-edit"
		          visible={ visible_edit }
		          title="Orden de Servicio"
		          centered
		          onClose={ () => this.onCloseEdit() }
		        >
		        	<ModalEdit
		        		onClose={ (open_date: boolean = false) => this.onCloseEdit(open_date) }
		        		item={ this.state.item }
		        	/>
		      	</Modal>

		      	<Modal
		          className="modal-quotes-edit-operators"
		          visible={ visible_edit_operators }
		          title="Lista de Operarios"
		          centered
		          onClose={ () => this.onCloseEditOperators() }
		        >
		        	<ModalEditOperators
		        		onClose={ () => this.onCloseEditOperators() }
		        		item={ this.state.item }
		        	/>
		      	</Modal>

		      	<Modal
		          className="modal-moderators-confirm-delete"
		          visible={ visible_confirm }
		          title=""
		          centered
		          onClose={ () => this.onCloseConfirm() }
		        >
					<div id="modal-moderators-confirm-delete">
						<img src={ ConfirmIcon } />
						<h3>¿Está seguro de cambiar el estatus de la cita a { next_status }?</h3>
						<div className="row">
							<div className="col-6 text-center">
								<button className="btn" onClick={ () => this.changeStatus() }>
									Aceptar
								</button>
							</div>
							<div className="col-6 text-center">
								<button className="btn btn-cancel" onClick={ () => {
									this.setState({
										visible_confirm: false,
										item: null
									});
								} }>
									Cancelar
								</button>
							</div>
						</div>
					</div>
		      	</Modal>

		      	<Modal
		          className="modal-moderators-message-delete"
		          visible={ visible_status }
		          title=""
		          centered
		          onClose={ () => this.onCloseStatus() }
		        >
					<div id="modal-moderators-message-delete">
						<img src={ StarIcon } />
						<h3>Se ha cambiado el estatus con éxito</h3>
					</div>
		      	</Modal>

		      	<Modal
		          className="modal-moderators-message-delete modal-copy-link"
		          visible={ visible_copy_link }
		          title=""
		          centered
		          onClose={ () => this.onCloseCopyLink() }
		        >
					<div id="modal-moderators-message-delete">
						<div className="container-copy-link">
							<Input
								onSubmit={ () => {
									navigator.clipboard.writeText(this.state.payment_link);
									this.setState({
										visible_confirm_copy: true
									});
								} }
								className="input-copy-link"
								searchRight
								searchIcon={ CopyIcon }
								value={ this.state.payment_link }
								placeholder="Enlace"
								disabled
								onChange={ (e: any) => {
									 
								} } />
							{
								visible_confirm_copy && (
									<p className="message-copy">Se ha copiado el enlace al portapapeles</p>
								)
							}
						</div>
					</div>
		      	</Modal>

		      	<Modal
		          className="modal-change-status-payment"
		          visible={ visible_payment }
		          title={ item?.price === 0 ? ("Pedido con descuento") : (updated_title || item?.payment_method?.name || (item?.bfc_payment_data != null ? 'BFC' : '-')) }
		          centered
		          onClose={ () => this.onClosePayment() }
		        >	
		        	{/*
		        	// @ts-ignore */}
					<ModalChangeStatusPayment
						updateTitleModal={ (updated_title: string) => {
							this.setState({
								updated_title
							});
						} }
						onClose={ (reload: boolean = false) => this.onClosePayment(reload) }
		        		item={ this.state.item }
					/>
		      	</Modal>

		      	<Modal
		          className="modal-moderators-confirm-delete"
		          visible={ visible_confirm_cancel }
		          title=""
		          centered
		          onClose={ () => this.onCloseConfirmCancel() }
		        >
					<div id="modal-moderators-confirm-delete">
						<img src={ ConfirmIcon } />
						<h3>¿Está seguro de cancelar la cita?</h3>
						<div className="row">
							<div className="col-6 text-center">
								<button className="btn" onClick={ () => this.cancel() }>
									Aceptar
								</button>
							</div>
							<div className="col-6 text-center">
								<button className="btn btn-cancel" onClick={ () => {
									this.setState({
										visible_confirm_cancel: false,
										item: null
									});
								} }>
									Cerrar
								</button>
							</div>
						</div>
					</div>
		      	</Modal>

		      	<Modal
		          className="modal-moderators-message-delete"
		          visible={ visible_cancel }
		          title=""
		          centered
		          onClose={ () => this.onCloseCancel() }
		        >
					<div id="modal-moderators-message-delete">
						<img src={ StarIcon } />
						<h3>Se ha cancelado la cita</h3>
					</div>
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-10">
						<div className="row">
							<div className="row col-md-10">
								<div className="col-md-4">
									<Input
										searchLeft
										value={ this.state.form.search }
										name="search"
										placeholder="Nombre"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
								<div className="col-md-4">
									<DatePicker
										placeholder="Desde"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'since'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.since }
									/>
								</div>
								<div className="col-md-4">
									<DatePicker
										placeholder="Hasta"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'until'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.until }
									/>
								</div>
								<div className="col-md-4">
									<Select
										placeholder="Estatus"
										name="status"
										onChange={ (e: any) => this.change(e,() => {
											this.load(true);
										}) }
										value={ this.state.form.status }
										options={ [
											{ value: Constants.QUOTE_STATUS.PENDING.toString(), label: 'Pendientes' },
											{ value: Constants.QUOTE_STATUS.ASSIGNED.toString(), label: 'Asignadas' },
											{ value: Constants.QUOTE_STATUS.IN_PROGRESS.toString(), label: 'En proceso' },
											{ value: Constants.QUOTE_STATUS.FINISH.toString(), label: 'Finalizadas' },
											{ value: Constants.QUOTE_STATUS.CANCELLED.toString(), label: 'Canceladas' }
										] } />
								</div>
								<div className="col-md-4">
									<Select
										placeholder="Tipo"
										name="type_id"
										onChange={ (e: any) => this.change(e,() => {
											this.load(true);
										}) }
										value={ this.state.form.type_id }
										options={ this.state.quote_types?.map((item: any) => {
											return {
												value: item.id,
												label: item.name
											}
										}) } />
								</div>
								<div className="col-md-4">
									<Select
										placeholder="Origen"
										name="origin"
										onChange={ (e: any) => this.change(e,() => {
											this.load(true);
										}) }
										value={ this.state.form.origin }
										options={ [
											{ value: Constants.QUOTES_ORIGIN.NORMAL.toString(), label: 'Web' },
											{ value: Constants.QUOTES_ORIGIN.ADMIN.toString(), label: 'Call Center' },
										] } />
								</div>
							</div>
							<div className="col-md-2">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
					<div className="col-md-2 text-right">
						{
							checkPermission(Constants.MODULES.QUOTES,'write') && (
								<button className="btn btn-add" onClick={ () => this.add() }>
									Nueva Cita
									<img src={ AddWhiteIcon } />
								</button>
							)
						}
					</div>
				</div>

				<Table data={ this.state.data.length } header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ i.number }</td>
								<td>{ i.user?.full_name || '-' }</td>
								<td>{ i.service?.type_id == Constants.SERVICE_TYPES.CLEAN ? i.type?.name : '-' }</td>
								<td className={ i.type_id == Constants.QUOTE_TYPES.URGENT ? 'urgent' : '' }>{ i.type_id == Constants.QUOTE_TYPES.URGENT ? ('Urgente ' + moment(i.date).format('DD/MM/YYYY')) : moment(i.date).format('DD/MM/YYYY') } { ' ' }
									{ moment(i.journey?.since,'HH:mm:ss').format('hh:mm A') } - { moment(i.journey?.until,'HH:mm:ss').format('hh:mm A') }
								</td>
								<td>{ i.service?.name }</td>
								<td>{ i.area }</td>
								<td className="bold">
									<a className="link-icon" href="#" onClick={ (e: any) => this.viewOperators(e,i) }>
										{ i.operators.length } Operario(s)
									</a>
								</td>
								<td>
									{
										[Constants.QUOTE_STATUS.IN_PROGRESS,Constants.QUOTE_STATUS.ASSIGNED].indexOf(i.status) != -1 ? (
											<a className="link-status" href="#" onClick={ (e: any) => this.showConfirmStatus(e,i) }>
												<p className="container-color" style={{
													color: this.getColor(i)
												}}>
													{ i.status_text }
												</p>
											</a>
										) : (
											<p className="container-color" style={{
												color: this.getColor(i)
											}}>
												{ i.status_text }
											</p>
										)
									}
								</td>
								<td>
									<a className="link-status" href="#" onClick={ (e: any) => {
										e.preventDefault();
										if (i.price !== null)
											this.showConfirmPaymentStatus(e,i);
									} }>
										<p className="container-color" style={{
											color: this.getPaymentColor(i)
										}}>
											{ i.status_payment_text }
										</p>
									</a>
									{
										i.status_payment != Constants.QUOTE_PAYMENT_STATUS.APPROVED && i.payment_method_id != Constants.PAYMENT_METHODS.CORPORATE && (
											<a href="#" className="copy-link" onClick={ (e: any) => this.generateLink(e,i) }>Enlace de pago <img src={ CopyIcon } /></a>
										)
									}
								</td>
								<td>{ i.origin_text }</td>
								<td>
									<Tooltip title="Ver">
										<a className="link-icon" href="#" onClick={ (e: any) => this.view(e,i) }>
											<img src={ ViewIcon } />
										</a>
									</Tooltip>
									{
										!i.price && i.status_payment == Constants.QUOTE_PAYMENT_STATUS.PENDING && i.type_id == Constants.QUOTE_TYPES.DEEP && checkPermission(Constants.MODULES.QUOTES,'write') && (
											<Tooltip title="Editar precio">
												<a className="link-icon" href="#" onClick={ (e: any) => this.editPrice(e,i) }>
													<img src={ MoneyIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										i.admin_allowed_to_edit && [Constants.QUOTE_STATUS.PENDING,Constants.QUOTE_STATUS.IN_PROGRESS,Constants.QUOTE_STATUS.ASSIGNED].indexOf(i.status) != -1 && checkPermission(Constants.MODULES.QUOTES,'write') && (
											<Tooltip title="Editar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
													<img src={ EditIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										[Constants.QUOTE_STATUS.PENDING,Constants.QUOTE_STATUS.IN_PROGRESS,Constants.QUOTE_STATUS.ASSIGNED].indexOf(i.status) != -1 && checkPermission(Constants.MODULES.QUOTES,'write') && (
											<Tooltip title="Operarios">
												<a className="link-icon" href="#" onClick={ (e: any) => this.operators(e,i) }>
													<img src={ OperatorsIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										i.admin_allowed_to_edit && [Constants.QUOTE_STATUS.PENDING,Constants.QUOTE_STATUS.IN_PROGRESS,Constants.QUOTE_STATUS.ASSIGNED].indexOf(i.status) != -1 && checkPermission(Constants.MODULES.QUOTES,'write') && (
											<Tooltip title="Cancelar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.confirmCancel(e,i) }>
													<img src={ CanceledIcon } />
												</a>
											</Tooltip>
										)
									}
									<Tooltip title="Imprimir">
										<a className="link-icon" href="#" onClick={ (e: any) => this.print(e,i) }>
											<img src={ PrintIcon } />
										</a>
									</Tooltip>
									{
										[Constants.QUOTE_STATUS.IN_PROGRESS,Constants.QUOTE_STATUS.ASSIGNED].indexOf(i.status) != -1 && (
											<Tooltip title="Reenviar correo">
												<a className="link-icon" href="#" onClick={ (e: any) => this.resendMail(e,i) }>
													<img src={ MailIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										i.survey != null && (
											<Tooltip title="Ver Encuesta">
												<a className="link-icon" href="#" onClick={ (e: any) => this.viewSurvey(e,i) }>
													<img src={ SurveyIcon } />
												</a>
											</Tooltip>
										)
									}
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect()(Quotes);